export default "__VITE_ASSET__wA3$CBVc__"